import script from "./PageStores.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageStores.vue?vue&type=script&setup=true&lang=ts"

import "./PageStores.vue?vue&type=style&index=0&id=6a292cc4&lang=css"

const __exports__ = script;

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QMenu,QTable});
